<template>
  <div>
    <TopBar id="top-bar"></TopBar>
    <div class="content-container">
      <ActionBar></ActionBar>
    </div>

    <div class="content-container">
      <b-row>
        <b-col align-self="stretch" class="container-item-epreuve" md="6" v-for="(epreuve, index) in list_epreuves"
          :key="index">
          <EpreuveItem :epreuve="epreuve" @deleteEpreuve="deleteEpreuve" @fixEpreuve="fixEpreuve"></EpreuveItem>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import TopBar from "@/component/Admin/TopBar";
import ActionBar from "@/component/Admin/ActionBar";
import EpreuveItem from "@/component/Admin/EpreuveItem";
export default {
  components: {
    TopBar,
    ActionBar,
    EpreuveItem,
  },
  data() {
    return {
      list_epreuves: [],
    };
  },
  methods: {
    deleteEpreuve(id) {
      var _this = this;
      axios
        .get(
          this.$store.getters.base_url + "/admin/epreuve/delete.php?id=" + id
        )
        .then(function (response) {
          _this.fetchEpreuves();
        });
    },
    fixEpreuve(id) {
      var _this = this;
      axios
        .get(
          this.$store.getters.base_url + "/admin/epreuve/fix.php?id=" + id
        )
    },
    fetchEpreuves() {
      var _this = this;
      axios
        .get(this.$store.getters.base_url + "/admin/epreuves/get.php")
        .then(function (response) {
          _this.list_epreuves = response.data;
        });
    },
  },
  created() {
    this.fetchEpreuves();
  },
};
</script>

<style scoped>
.container-item-epreuve {
  margin-top: 20px;
}
</style>
